import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import { Form, InputNumber } from "antd"
import { formItemLayout } from "./SettingFormItems"
import { WrappedFormUtils } from "antd/lib/form/Form"

type Props = {
    data: {
        key: string
        value: Maybe<any>
        indeterminate: boolean
    }
    label: Maybe<React.ReactNode>
    description?: Maybe<React.ReactNode>
    placeholder: string
    form: WrappedFormUtils
    style: Maybe<Record<string, any>>
    min?: number
    max?: number
    onChangeCallback: () => void
    className?: string
    disabled?: boolean
    customFormItemLayout?: Record<string, any>
    inputStyle?: Maybe<Record<string, any>>
}

/* Accepts value in DOLLARS */

export const FormInputPriceValue = ({
    data,
    label,
    description,
    placeholder,
    form,
    style,
    min = -Infinity,
    max = Infinity,
    onChangeCallback,
    className = "setting-form-item",
    disabled = false,
    customFormItemLayout = {},
    inputStyle = {},
}: Props) => {
    const options = {
        initialValue:
            (form.getFieldValue(data.key) ? Number(form.getFieldValue(data.key)) : 0) || data.value
                ? Number(data.value)
                : undefined,
        preserve: true,
    }
    return (
        <div>
            <Form.Item
                style={{
                    marginBottom: "0rem",
                    ...style,
                }}
                className={className}
                {...(customFormItemLayout || formItemLayout)}
                label={label}>
                {form.getFieldDecorator(
                    data.key,
                    options
                )(
                    <InputNumber
                        style={{
                            width: "12rem",
                            marginRight: 0,
                            ...inputStyle,
                        }}
                        onFocus={e => e.target.select()}
                        min={min}
                        max={max}
                        disabled={disabled}
                        formatter={value => {
                            // @ts-expect-error
                            if (value && shouldConvertToNegative(value, max)) {
                                return value ? `-$${value}` : `$${value}`
                            }

                            // @ts-expect-error
                            if (value < 0) {
                                // @ts-expect-error
                                const newVal = value * -1
                                return `-$${newVal}`
                            }

                            return `$${value}`
                        }}
                        parser={value => {
                            const num = value ? value.replace("$", "") : value
                            return `${shouldConvertToNegative(Number(value), max) ? "-" : ""}${num}`
                        }}
                        onChange={val => {
                            if (val) {
                                form.setFieldsValue({
                                    [data.key]: shouldConvertToNegative(val, max) ? -(val * 100) : val * 100,
                                })
                            }

                            onChangeCallback()
                        }}
                        placeholder={data.indeterminate ? "Multiple values" : placeholder}
                    />
                )}
            </Form.Item>
            {description}
        </div>
    )
}

const shouldConvertToNegative = (value: Maybe<number>, inputMax: Maybe<number>) =>
    inputMax != null && inputMax <= 0 && value && value > 0
